import { SxProps } from '@mui/material';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme();

export const accordion: SxProps = {
  boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
  borderRadius: '8px',

  '&.MuiAccordion-root:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    m: 0,
  },
  '&.Mui-disabled': {
    backgroundColor: '#ffffff',
  },
};

export const accordionDetails: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 28px 32px',
  [theme.breakpoints.down('lg')]: {
    padding: '0px 20px 32px',
  },
};
export const accordionSummary: SxProps = {
  display: 'inline-flex',
  height: '114px',
  padding: '32px 32px',
  '&.Mui-disabled': {
    opacity: 1,
  },

  [theme.breakpoints.down(700)]: {
    padding: '16px 20px',
  },
  // [theme.breakpoints.down('lg')]: {
  //   padding: '20px 18px',
  //   height: 'auto',
  //   minHeight: '114px',
  //   alignItems: 'start',
  //   '& .MuiAccordionSummary-expandIconWrapper': {
  //     mt: '12px',
  //   },
  // },
  // [theme.breakpoints.down('md')]: {
  //   alignItems: 'center',
  //   '& .MuiAccordionSummary-expandIconWrapper': {
  //     mt: '0px',
  //   },
  // },
  // [theme.breakpoints.down(855)]: {
  //   height: 'auto',
  //   minHeight: '114px',
  //   alignItems: 'start',
  //   '& .MuiAccordionSummary-expandIconWrapper': {
  //     mt: '12px',
  //   },
  // },
  // [theme.breakpoints.down('sm')]: {
  //   '& .MuiAccordionSummary-expandIconWrapper': {
  //     position: 'absolute',
  //     right: '5%',
  //   },
  // },
};
